<template>
  <div class="account-nav-tab">
    <button
      class="btn"
      type="button"
      v-for="option in options"
      :key="option.id"
      :class="{ active: value === option.id }"
      @click="$emit('input', option.id)"
    >
      <i class="fas mr-1" :class="option.icon"></i>
      {{ option.name }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    topics: Number,
    comments: Number
  },
  data() {
    return {
      options: [
        { id: "bio", name: "Perfil", icon: "fa-user" },
        { id: "topics", name: `${this.topics} tópicos`, icon: "fa-pencil-alt" }
        // {
        //   id: "comments",
        //   name: `${this.comments} respostas`,
        //   icon: "fa-comment-alt"
        // }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.account-nav-tab {
  display: flex;
  margin-bottom: 24px;
  border-bottom: 1px solid #373737;

  button {
    padding: 4px 32px;
    color: #787878;
    font-weight: 400;
    font-size: 14px;
    box-shadow: none;
    &.active {
      color: white;
      border-bottom: 2px solid #fb263e;
      border-radius: 0;
      background-color: #fb263e;
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
    }
  }
}
</style>
